import type * as Types from '@__graphql__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetRequiredBaseProductsQueryVariables = Types.Exact<{
  languages?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['String']>> | Types.InputMaybe<Types.Scalars['String']>>;
  skus?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['String']>> | Types.InputMaybe<Types.Scalars['String']>>;
}>;


export type GetRequiredBaseProductsQuery = { content?: { required_base_products: Array<{ sku: string, messages?: Array<{ id: string, required_base_products?: string | null, languages_code?: { code: string } | null } | null> | null }> } | null };


export const GetRequiredBaseProductsDocument = gql`
    query GetRequiredBaseProducts($languages: [String], $skus: [String]) {
  content {
    required_base_products(filter: {sku: {_in: $skus}}) {
      sku
      messages(filter: {languages_code: {code: {_in: $languages}}}) {
        id
        required_base_products
        languages_code {
          code
        }
      }
    }
  }
}
    `;

/**
 * __useGetRequiredBaseProductsQuery__
 *
 * To run a query within a React component, call `useGetRequiredBaseProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequiredBaseProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequiredBaseProductsQuery({
 *   variables: {
 *      languages: // value for 'languages'
 *      skus: // value for 'skus'
 *   },
 * });
 */
export function useGetRequiredBaseProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetRequiredBaseProductsQuery, GetRequiredBaseProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequiredBaseProductsQuery, GetRequiredBaseProductsQueryVariables>(GetRequiredBaseProductsDocument, options);
      }
export function useGetRequiredBaseProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRequiredBaseProductsQuery, GetRequiredBaseProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequiredBaseProductsQuery, GetRequiredBaseProductsQueryVariables>(GetRequiredBaseProductsDocument, options);
        }
export type GetRequiredBaseProductsQueryHookResult = ReturnType<typeof useGetRequiredBaseProductsQuery>;
export type GetRequiredBaseProductsLazyQueryHookResult = ReturnType<typeof useGetRequiredBaseProductsLazyQuery>;
export type GetRequiredBaseProductsQueryResult = Apollo.QueryResult<GetRequiredBaseProductsQuery, GetRequiredBaseProductsQueryVariables>;